export class ComplainModel {
  public ID?: number;
  public UID?: number;
  public Username?: string;
  public Status?: number;
  public OrderID?: number;
  public Amount?: number;
  public AmountNDT?: number;
  public Img?: string;
  public Files?: string;
  public ComplainText?: string;
  public TransactionCode?: string;
  public CreatedDate?: string;
  public StatusDetail?: any;
  public IsMissGood?: boolean;
  public IsBroken?: boolean;
  public IsOption?: boolean;
  public IsOther?: boolean;
  public NoteOfStaff?: string;
  public OrderType?: number;
  public NoteForUser?: string;
  public ExchangeRate?: number;
  public IgnoreRefund?: boolean;
  public SndOrderID?: number;
  public SndOrderType?: number;
  public StaffID?: number;
  public ResMethod?: number;
}